import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import { LockOutlined } from "@ant-design/icons";

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <Result
        icon={
          <div className="animate-bounce text-red-500">
            <LockOutlined style={{ fontSize: 64 }} />
          </div>
        }
        status="403"
        title={
          <span className="text-3xl font-semibold text-gray-800">
            Access Denied
          </span>
        }
        subTitle={
          <p className="text-gray-500 text-base mt-2">
            You do not have permission to view this page.
          </p>
        }
        extra={
          <div className="flex gap-3 justify-center">
            <Button type="primary" onClick={() => navigate(-1)}>
              Go Back
            </Button>
            <Button onClick={() => navigate("/dashboard")}>Home</Button>
          </div>
        }
      />
    </div>
  );
}
